import React from "react";
import { useSelector } from "react-redux";
import StepCheckoutForte from "../StepCheckoutForte/StepCheckoutForte";
import StepCheckoutStax from "../StepCheckoutStax/StepCheckoutStax";

/**
 * UnifiedCheckout acts as a single integration point for page 3 checkout.
 * It selects the appropriate merchant implementation based on
 * appInfo.registration_info.merchant and domain.
 *
 * This is Phase 1: unifies selection without rewriting internals.
 * Phase 2 can refactor into provider adapters behind a single UI.
 */
const UnifiedCheckout = (props) => {
  const { appInfo } = props;
  const appDataStore = useSelector((x) => x.appDataStore);

  const merchant = appInfo?.registration_info?.merchant ||
    appDataStore?.appInfo?.registration_info?.merchant || "stax";

  const isStax = merchant === "stax";

  if (isStax) {
    return <StepCheckoutStax {...props} />;
  }

  return <StepCheckoutForte {...props} />;
};

export default UnifiedCheckout;
